import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Customer Profile Overview</h2>
      <p>
        Customer Profiles help centralise and manage all key information about your customers in one
        secure location. Use this section to maintain up-to-date records for each customer and
        support consistency across your customer service, sales, and admin workflows.
      </p>
      <p>This section allows you to manage:</p>
      <ul>
        <li>
          <strong>Profile identification:&nbsp;</strong>Create and maintain profiles for
          associations, businesses, or individual leads with clear and consistent labelling.
        </li>
        <li>
          <strong>Document storage:&nbsp;</strong>Upload or link relevant customer documents such as
          onboarding forms, sales spreadsheets, or historical notes for easy reference.
        </li>
        <li>
          <strong>Status tracking:&nbsp;</strong>Record customer engagement and follow-ups
          effectively.
        </li>
        <li>
          <strong>Profile management:&nbsp;</strong>Edit individual customer profiles as customers
          evolve or change.
        </li>
        <li>
          <strong>Organisational visibility:&nbsp;</strong>Ensure the team can quickly locate and
          understand customer history and context to improve service and communication.
        </li>
      </ul>
      <p>
        <strong>Tip:&nbsp;</strong>Keeping these customer profiles current ensures your sales,
        support, and admin processes run smoothly, enhances customer experience, and supports better
        internal records.
      </p>
    </div>
  );
};

export default Preview;
